"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFoundAircraftAction = exports.setEmailVerified = exports.setShowPopup = exports.setResendVerification = exports.setLicenseTypesAction = exports.setPilotProfileAction = exports.setAsAPilotAction = exports.setUserDetailsAction = exports.setPlatformAction = exports.newUserAck = exports.logoutAction = exports.setAccountError = exports.authenticateAction = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const lodash_1 = require("lodash");
const DEFAULT_STATE = {
    accessToken: null,
    isAuthenticated: false,
    expDate: null,
    newUser: false,
    details: null,
    platform: null,
    error: null,
    asAPilot: false,
    pilotProfile: {
        stopovers: false,
        bio: "",
        aircraft: [],
        license: {},
    },
    licenseTypes: [],
    resendVerificationButton: false,
    showPopup: '',
    emailVerified: false,
    foundAircraft: []
};
const accountSlice = (0, toolkit_1.createSlice)({
    name: 'account',
    initialState: DEFAULT_STATE,
    reducers: {
        authenticate: (state, action) => {
            return {
                ...state,
                isAuthenticated: true,
                accessToken: action.payload.accessToken,
                expDate: action.payload.expDate,
                newUser: action.payload.newUser ?? DEFAULT_STATE.newUser,
                error: DEFAULT_STATE.error
            };
        },
        setError: (state, action) => {
            return { ...state, error: action.payload };
        },
        logout: (state) => {
            return { ...state, ...(0, lodash_1.omit)(DEFAULT_STATE, 'platform') };
        },
        newUserAck: (state) => {
            return {
                ...state,
                newUser: false,
                error: DEFAULT_STATE.error
            };
        },
        setPlatform: (state, action) => {
            return {
                ...state,
                platform: action.payload.platform
            };
        },
        setUserDetails: (state, action) => {
            return {
                ...state,
                details: {
                    ...action.payload
                }
            };
        },
        setAsAPilot: (state, action) => {
            return {
                ...state,
                asAPilot: action.payload
            };
        },
        setPilotProfile: (state, action) => {
            return {
                ...state,
                pilotProfile: {
                    ...state.pilotProfile,
                    ...action.payload
                }
            };
        },
        setLicenseTypes: (state, action) => {
            return {
                ...state,
                licenseTypes: action.payload
            };
        },
        setResendVerificationButton: (state, action) => {
            return {
                ...state,
                resendVerificationButton: action.payload
            };
        },
        setShowPopup: (state, action) => {
            return {
                ...state,
                showPopup: action.payload
            };
        },
        setEmailVerified: (state, action) => {
            return {
                ...state,
                emailVerified: action.payload
            };
        },
        setFoundAircraft: (state, action) => {
            return {
                ...state,
                foundAircraft: action.payload
            };
        },
    }
});
exports.default = accountSlice.reducer;
exports.authenticateAction = accountSlice.actions.authenticate;
exports.setAccountError = accountSlice.actions.setError;
exports.logoutAction = accountSlice.actions.logout;
exports.newUserAck = accountSlice.actions.newUserAck;
exports.setPlatformAction = accountSlice.actions.setPlatform;
exports.setUserDetailsAction = accountSlice.actions.setUserDetails;
exports.setAsAPilotAction = accountSlice.actions.setAsAPilot;
exports.setPilotProfileAction = accountSlice.actions.setPilotProfile;
exports.setLicenseTypesAction = accountSlice.actions.setLicenseTypes;
exports.setResendVerification = accountSlice.actions.setResendVerificationButton;
exports.setShowPopup = accountSlice.actions.setShowPopup;
exports.setEmailVerified = accountSlice.actions.setEmailVerified;
exports.setFoundAircraftAction = accountSlice.actions.setFoundAircraft;
